<script>
import Theme from '@/theme'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Checkbox from '@/components/Checkbox'
import StringUtils from '@/utils/stringUtils'
import Draggable from 'vuedraggable'
import ArrayUtils from '@/utils/arrayUtils'

export default
{
    name: 'display-theme-palette',

    render () 
    {
        return (
            <div id='display-theme-palette-view'>
                <floating-label-text-input placeholder='Search properties Regex' v-model={this.searchRegex} />
                <div class='row'>
                    <checkbox label='background' value={true} on-click={c => this.toggleDisplayType('background', c)} />
                    <checkbox label='border' on-click={c => this.toggleDisplayType('border', c)} />
                </div>
                <draggable>
                    {Object.entries(this.filteredProperties || {}).map(p => <div class={`color-preview ${this.displayTypes.join(' ')}`} style={{'--value': p[1]}}>{p[0]}</div>)}
                </draggable>
            </div>
        )
    },

    data () 
    {
        return {
            searchRegex: '',
            displayTypes: ['background']
        }
    },

    computed:
    {
        filteredProperties ()
        {
            if (StringUtils.isEmptyString(this.searchRegex))
            {
                return Theme.properties
            }

            try
            {
                return Object.fromEntries(Object.entries(Theme.properties).filter(pair => pair[0].match(this.searchRegex)))
            }
            catch(e)
            {
                console.error(e)
            }
        }
    },

    mounted ()
    {
    },

    methods:
    {
        toggleDisplayType (type, toggled)
        {
            if (toggled)
            {
                this.displayTypes.push(type)
            }
            else
            {
                ArrayUtils.removeByValue(this.displayTypes, type)
            }
        }
    },

    components:
    {
        FloatingLabelTextInput,
        Draggable,
        Checkbox
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#display-theme-palette-view
{
    .row
    {
        display: flex;
        flex-direction: row;
    }

    .color-preview
    {
        width: -webkit-fill-available;
        height: 50px;

        &.background
        {
            background: var(--value);
        }

        &.border
        {
            border: 2px solid var(--value);
            margin: 6px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/DisplayThemePalette.vue